import { adminRoutes } from "@/helpers/router/admin/routes";
import { clientRoutes } from "@/helpers/router/client/routes";

export default [
  adminRoutes,
  clientRoutes
];
